'use client';

import styled from '@emotion/styled';
import { usePathname, useSearchParams } from 'next/navigation';
import React from 'react';
import { IGenericPageProps } from '../../home/ui/HomePage';
import GenericPage from '../../app/pages/ui/GenericPage';
import { ContentWrap, Css, Responsive } from '../../../ui';
import { Color } from '../../../styles/Color';
import { getCurrentAirportCodeFromSlug } from '../../../components/common/navigation/utils/getCurrentAirportCode';
import { getAirportMapUrl } from '../domain/helpers/getAirportMapUrl';
import { ISiteSectionEntry } from '../../../contentful/types/ISiteSection';
import { Z_INDEX_BASE_MAP_IFRAME } from '../../../styles/zIndex';

interface IAoCMapPageProps extends IGenericPageProps {
	siteSection?: ISiteSectionEntry;
}

const StyledContentWrap = styled(ContentWrap)`
	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		margin: 0;
	}
`;

export const StyledMapIframe = styled.iframe`
	background-color: ${Color.Neutral1};
	position: relative;
	display: flex;
	flex-direction: column;
	width: 93%;
	height: ${Css.pxToRem(700)};
	margin-top: -${Css.pxToRem(124)};
	border: ${Css.pxToRem(24)} solid ${Color.Neutral1};
	outline: 1px solid ${Color.BorderCard};
	border-radius: 16px;
	z-index: ${Z_INDEX_BASE_MAP_IFRAME};
	margin-bottom: ${Css.pxToRem(80)};

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		width: 100% !important;
	}
	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		height: 520px;
		border: 0;
		border-radius: 0;
		margin-top: -${Css.pxToRem(96)};
		margin-bottom: ${Css.pxToRem(60)};
	}
`;

export default function MapPage({ page, siteSection }: IAoCMapPageProps) {
	const searchParams = useSearchParams();
	const assetId = searchParams.get('assetId');
	const pathname = usePathname();
	const airport = getCurrentAirportCodeFromSlug(pathname);
	const airportMapUrl = getAirportMapUrl(airport);

	const iframeSrc = assetId
		? `${airportMapUrl.url}assetview/${assetId}`
		: airportMapUrl.url;

	return (
		<GenericPage page={page} siteSection={siteSection}>
			<StyledContentWrap>
				<StyledMapIframe src={iframeSrc} title="Interactive map" />
			</StyledContentWrap>
		</GenericPage>
	);
}
